import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2090d4a5&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=2090d4a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2090d4a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2090d4a5')) {
      api.createRecord('2090d4a5', component.options)
    } else {
      api.reload('2090d4a5', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=2090d4a5&scoped=true", function () {
      api.rerender('2090d4a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pluginManage/pluginConfig/components/add.vue"
export default component.exports